import React, { useEffect, useState } from "react";
import VendorHeader from "../../CustomComponents/Property/VendorHeader/VendorHeader";
import SideBar from "../../CustomComponents/Property/SideBar/SideBar";
import AllRooms from "../../CustomComponents/Property/AllRooms/AllRooms";
import { useRef } from "react";
import SeeBookingSlider from "../../CustomComponents/SeeBookingsSlider/SeeBookingsSlider";
import { useParams } from "react-router-dom";
import { formatIndianCurrency, textDateFormatter } from "../../utils/utils";
import Loader from "../../CustomComponents/Loader/Loader";
import NoDataFound from "../../CustomComponents/NoDataFound/NoDataFound";
import VendorPackages from "../VendorPackages/VendorPackages";
import styles from "./Bookings.module.scss";

function Bookings({ allPropertiesPage }) {
  const [editPopup, setEditPopup] = useState(null);
  const [singleSliderBookingData, setSliderSingleBookingData] = useState(null);
  const userToken = localStorage.getItem("token");
  const [selectedButton, setSelectedButton] = useState("accommodation");
  const [loader, setLoader] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoader(false);
    }, 500);
  }, []);

  const [singleBookingData, setSingleBookingData] = useState([]);

  const [isSliderVisible, setIsSliderVisible] = useState(false);
  const { id: propertyId } = useParams();

  const handleOnClick = (index) => {
    if (editPopup === index) {
      setEditPopup(null); // Close if the same index is clicked again
    } else {
      setEditPopup(index); // Open for the clicked index
    }
  };

  const handleCloseSlider = () => {
    setIsSliderVisible(false);
  };

  const popupsRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (popupsRef.current && !popupsRef.current.contains(event.target)) {
        setEditPopup(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  // const fetchBookingData = (id) => {
  //   setLoader(true);
  //   const requestOptions = {
  //     headers: {
  //       "Content-Type": "application/json",
  //       key: "D4X50uU40Vz4pweFLEmsoiJy107iPfTD4ompprop1",
  //       Authorization: "Bearer " + localStorage.getItem("token"),
  //     },
  //     method: "GET",
  //     redirect: "follow",
  //   };

  //   fetch(
  //     `${process.env.REACT_APP_APP_URL}/api/v1/vendor/get-bookings/${propertyId}`,
  //     requestOptions
  //   )
  //     .then((response) => response.json())
  //     .then((result) => {
  //       // console.log("result", result);

  //       if (result.success) {
  //         setSingleBookingData(result?.bookings);
  //         setLoader(false);
  //       } else {
  //         setLoader(false);
  //         setSingleBookingData([]);
  //       }
  //     })
  //     .catch((error) => console.error(error));
  // };

  const fetchBookingData = async () => {
    setLoader(true);
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${userToken}`,
      Cookie: process.env.REACT_APP_COOKIE,
    };

    const body = {
      booking_type: "accommodation",
      account_type: "supplier",
      accommodation_id: Number(propertyId),
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/supplier/bookings/fetch/list`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(body),
        }
      );

      const result = await response.json();
      setSingleBookingData(result?.data);
      setLoader(false)
    } catch (error) {
      console.error("Error:", error);
      setLoader(false)
    }
  };

  const fetchSidebarDetails = async (bookingId) => {
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${userToken}`,
      Cookie: process.env.REACT_APP_COOKIE,
    };

    const raw = JSON.stringify({
      booking_type: "accommodation",
    });

    const requestOptions = {
      method: "POST",
      headers: headers,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/supplier/bookings/fetch/single/${bookingId}`,
        requestOptions
      );

      const result = await response.json();
      console.log(result);
      setSliderSingleBookingData(result?.data);
      setIsSliderVisible(true);
    } catch (error) {
      console.error("Error fetching booking details:", error);
    }
  };

  useEffect(() => {
    if (propertyId) {
      fetchBookingData(propertyId);
    }
  }, [propertyId]);

  return (
    <>
      <div className="sidebar_main_div new_sidebar_main_div">
        <SideBar allPropertiesPage={false} />
        <div className="agent-info-container">
          <VendorHeader showSelectProperty={true} vendorProperty={false} />
          {loader ? (
            <Loader size="4em" color="#009A50" />
          ) : (
            <section className="w-full mt-10">
              <div className={styles.agent_bookings_section}>
                <div>
                  <h4>Bookings</h4>
                </div>

                <div className={styles.total_bookings_sec}>
                  <div className={styles.total_bookings_sec_item}>
                    Total Bookings
                    <span>{singleBookingData?.length}</span>
                    <span>0</span>
                  </div>
                  <div className={styles.total_bookings_sec_item}>
                    Confirmed
                    <span>
                      {/* {
                      allBookingsCount?.filter(
                        (item) => item.status === "confirm"
                      ).length
                    } */}
                      0
                    </span>
                  </div>
                  <div className={styles.total_bookings_sec_item}>
                    Hold
                    <span>
                      {/* {
                      allBookingsCount?.filter((item) => item.status === "hold")
                        .length
                    } */}
                      0
                    </span>
                  </div>
                  <div className={styles.total_bookings_sec_item}>
                    Cancelled
                    <span>
                      {/* {
                      allBookingsCount?.filter(
                        (item) => item.status === "cancelled"
                      ).length
                    } */}
                      0
                    </span>
                  </div>
                </div>
              </div>
              {selectedButton === "accommodation" ? (
                <>
                  {" "}
                  {loader ? (
                    <Loader size="4em" color="#016937" />
                  ) : (
                    <>
                      {/* <div className="overflow_x_scroll_y_hidden">
                    {singleBookingData && singleBookingData.length > 0 ? (
                      <table className="rates_table">
                        <tr>
                          <th>Booking Details</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Total Amt.</th>
                          <th>Paid Amt.</th>
                          <th>Due Amt.</th>
                          <th>Booking Status</th>
                          <th></th>
                        </tr>
                        {singleBookingData &&
                          singleBookingData?.map((item, index) => (
                            <React.Fragment key={index}>
                              <td>
                                <div
                                  className="link_btn pt_10"
                                  onClick={() =>
                                    fetchSidebarDetails(
                                      item?.id
                                    )
                                  }
                                >
                                  {" "}
                                  #{item?.bookingNo}
                                </div>
                              </td>
                              <td className="border-bottom">
                                {" "}
                                {item?.customerDetails?.email}
                              </td>
                              <td className="border-bottom ">
                                {item?.customerDetails?.phone}
                              </td>
                              <td className="border-bottom ">
                                {formatIndianCurrency(item?.grandTotal)}
                              </td>
                              <td className="border-bottom ">
                                {formatIndianCurrency(item?.paidAmount)}
                              </td>
                              <td
                                style={{ color: "#009A50" }}
                                className="border-bottom "
                              >
                                {formatIndianCurrency(item?.dueAmount)}
                              </td>
                              <td
                                className="border-bottom "
                              >
                                {item?.status}
                              </td>
                              <td className="border-bottom ">
                                <button className="confirmed_btn">
                                  {item?.booking_status}
                                </button>
                              </td>
                            </React.Fragment>
                          ))}
                      </table>
                    ) : (
                      <NoDataFound />
                    )}

                    {isSliderVisible && (
                      <SeeBookingSlider
                        singleBookingData={singleSliderBookingData}
                        onClose={handleCloseSlider}
                        setIsSliderVisible={setIsSliderVisible}
                      />
                    )}
                  </div> */}
                      <div id="common_background_profile ">
                        <div className="">
                          <div className="profile_content Bookings">
                            {singleBookingData &&
                              singleBookingData.length > 0 ? (
                              <div className={styles.tableContainer}>
                                <div
                                  className="overflow_x_scroll_y_hidden"
                                  id="csv_download"
                                >
                                  <table
                                    className="m_0"
                                  // id="customTable"
                                  >
                                    <thead>
                                      <tr>
                                        <th>Booking Details</th>
                                        <th>Email</th>
                                        <th>Phone</th>
                                        <th>Total Amt.</th>
                                        <th>Paid Amt.</th>
                                        <th>Due Amt.</th>
                                        <th>Booking Status</th>
                                        {/* <th></th> */}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {singleBookingData.map((item, index) => (
                                        <tr key={index}>
                                          <td className="border-bottom">
                                            <div
                                              className="link_btn pt_10"
                                              onClick={() =>
                                                fetchSidebarDetails(item?.id)
                                              }
                                            >
                                              #{item?.bookingNo}
                                            </div>
                                          </td>
                                          <td className="border-bottom">
                                            {item?.customerDetails?.email}
                                          </td>
                                          <td className="border-bottom">
                                            {item?.customerDetails?.phone}
                                          </td>
                                          <td className="border-bottom">
                                            {formatIndianCurrency(
                                              item?.grandTotal
                                            )}
                                          </td>
                                          <td className="border-bottom">
                                            {formatIndianCurrency(
                                              item?.paidAmount
                                            )}
                                          </td>
                                          <td
                                            className="border-bottom"
                                            style={{ color: "#009A50" }}
                                          >
                                            {formatIndianCurrency(
                                              item?.dueAmount
                                            )}
                                          </td>
                                          <td className="border-bottom">
                                            <span
                                              className={`${styles.tableStatus
                                                } text-capitalize ${item.status === "confirmed"
                                                  ? styles.confirm
                                                  : styles.cancelled
                                                }`}
                                            >
                                              {item?.status}
                                            </span>
                                          </td>
                                          {/* <td className="border-bottom">
                                          <button className="confirmed_btn">
                                            {item?.booking_status}
                                          </button>
                                        </td> */}
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            ) : (
                              <NoDataFound />
                            )}
                          </div>
                        </div>
                      </div>

                      {isSliderVisible && (
                        <SeeBookingSlider
                          singleBookingData={singleSliderBookingData}
                          onClose={handleCloseSlider}
                          setIsSliderVisible={setIsSliderVisible}
                        />
                      )}
                    </>
                  )}
                </>
              ) : (
                <>
                  <VendorPackages
                    selectedButton={selectedButton}
                    setSelectedButton={setSelectedButton}
                  />
                </>
              )}
            </section>
          )}
        </div>
      </div>
    </>
  );
}

export default Bookings;
